import React, { useState, useEffect } from 'react';
import { Grid, GridColumn, GridNoRecords } from '@progress/kendo-react-grid';
import { useTranslation } from 'react-i18next';
import { useMediaQuery } from '@material-ui/core';
import './gridSimpleReadHL.css';
import { profileIconDefault } from '../../../assets/logos/icons';

const GridSimpleReadHLPure = (props) => {
  const {
    customClassGrid,
    skip, //Number pagination {0}
    take, //Number pagination {6}
    dataGrid, //Array information to grid
    titleRow1, //Header first column
    fieldRow1, //Body information row to first column
    fieldSubtitle, //Subtitle first column
    textSubtitle, //Text more subtitle first column
    filter, //True to filter grid
    onFilterChange, //Filter function to grid
    onSelectedItem, //Select information item grid
    styleCol1, //Class to td (col1) from table, especifies width
    iconAvatar, //True to show avatar image or false to not show
    fieldImg, //Choose image th
    fieldRow2, //Header second column
    titleRow2, //Body information row to second column
    styleCol2, //Class to td (col2) from table, especifies width
    styleHeader2,
    column2Status, //True to active second column
    labelOneActions, //Label fisrt item action
    handleOnClick, //function btn onclick
    btnFileActiveCol2, // Activar btn file en la col 2 true, false to pass text
    iconIsBtn, // icon is a btn or not send true or false
    handleIconBtn, // function icon Btn
    pageableGrid, //True or false, to pagination
    iconArrowClick, // icon is a btn or not send true or false, true active funtion onclick
    iconArrow, //True to active the arrow icon
    handleIconArrow, //Funtion onclick arrow
    rowClick, //Function onclick in the row
    columnThree, //True to active third column
    titleRow3, //Header third column
    fieldRow3, //Body information row to third column
    textSubtitleColumn3, //add two rows information to third column
    textStyleColumn3, //more information in column 3
    styleCol3, //Class to td (col3) from table, especifies width
    styleHeader3,
    startTextHeader3,
    containerColumn3, //Class container column 3 if exist textSubtitleColumn3
    containerColumnMobile3, //Class container column 3 if exist textSubtitleColumn3 and screen is in mobileResolution
    columnFour,
    columnFourField,
    coulmnFourTitle,
    columnFourCell,
    noRecordsElement
  } = props;
  const { t } = useTranslation();

  const initialDataState = {
    skip,
    take,
  };

  const [page, setPage] = useState(initialDataState);
  const mobileResolution = useMediaQuery('(max-width:720px)');
  const [selectedItem, setSelectedItem] = useState({});

  const rowRender = (trElement, props) => {
    const available = !props.dataItem.selected;
    const green = {
      backgroundColor: '',
    };
    const selected = {
      backgroundColor: '#E3E4E8',
    };
    const trProps = {
      style: available ? green : selected,
    };
    return React.cloneElement(
      trElement,
      {
        ...trProps,
      },
      trElement.props.children
    );
  };

  const SignRequestCellHeader = (props) => {
    const cellHeaderStyles = {
      color: '#123513',
      fontSize: '14px',
      fontWeight: 600,
      display: 'flex',
      justifyContent: 'start',
      fontFamily: 'Quicksand',
    };
    return <span style={cellHeaderStyles}>{props.title}</span>;
  };

  const SignRequestCellHeaderColum3 = (props) => {
    const cellHeaderStyles = {
      color: '#123513',
      fontSize: '14px',
      fontWeight: 600,
      display: 'flex',
      justifyContent: startTextHeader3 ? 'start' : 'center',
      fontFamily: 'Quicksand',
    };
    return <span style={cellHeaderStyles}>{props.title}</span>;
  };

  const avatarCell = (props) => {
    return (
      <td
        className={styleCol1}
        onClick={rowClick ? () => handleIconArrow(props.dataItem) : ''}
      >
        <div
          className={
            iconArrow
              ? 'gridSimpleReadHLPure-containerAvatarArrow'
              : 'gridSimpleReadHLPure-containerAvatar'
          }
        >
          {iconAvatar === true ? (
            // iconIsBtn ? (
            //   <div className='gridHLPure-imageAvatar'>
            //     <Button
            //       onClick={() => handleIconBtn(props.dataItem)}
            //     >
            //       <img
            //         alt='profile-img'
            //         src={props.dataItem[fieldImg] || profileIconDefault}
            //         className='gridHLPure-avatar'
            //       />
            //     </Button>
            //   </div>
            // ) : (
            <div className='gridSimpleReadHLPure-imageAvatar'>
              <img
                alt='profile-img'
                src={props.dataItem[fieldImg] || profileIconDefault}
                className='gridSimpleReadHLPure-avatar'
                onClick={iconIsBtn ? () => handleIconBtn(props.dataItem) : ''}
              />
            </div>
          ) : (
            // ) : (
            //   ''
            // )
            ' '
          )}
          <div className='gridSimpleReadHLPure-containerLabel'>
            <span className='gridSimpleReadHLPure-userName'>
              {props.dataItem[fieldRow1] || '----'}
            </span>
            <div className='gridSimpleReadHLPure-detailsContainer'>
              <span className='gridSimpleReadHLPure-fieldSubtitle'>
                {textSubtitle && fieldSubtitle
                  ? props.dataItem[textSubtitle] +
                  ' ' +
                  props.dataItem[fieldSubtitle]
                  : textSubtitle}
              </span>
            </div>
          </div>
          {iconArrow ? (
            <div
              className='gridSimpleReadHLPure-arrowIcon'
              onClick={
                iconArrowClick ? () => handleIconArrow(props.dataItem) : ''
              }
            >
              {'>'}
            </div>
          ) : (
            ''
          )}
        </div>
      </td>
    );
  };


  const columnTwoCell = (props) => {
    return (
      <td className={styleCol2}>
        {btnFileActiveCol2 ? (
          <div className={'cellActions-containerBtnsDetails'}>
            <button
              className='cellActions-btn'
              onClick={() => handleOnClick(props.dataItem)}
              data-id={labelOneActions}
            >
              <p className='cellActions-textBotton'>{labelOneActions}</p>
            </button>
          </div>
        ) : (
          /*Texto sacado con props.dataItem[fieldRow2]*/
          props.dataItem[fieldRow2]
        )}
      </td>
    );
  };

  const columnThreeCell = (props) => {
    return (
      <td className={styleCol3}>
        {textSubtitleColumn3 ? (
          <div
            className='gridSimpleReadHLPure-container-column-3'
            style={mobileResolution ? containerColumnMobile3 : containerColumn3}
          >
            <h5>{props.dataItem[fieldRow3]}</h5>
            <h5>{props.dataItem[textSubtitleColumn3]}</h5>
            {props.dataItem[textStyleColumn3] === 'Propuesta' ? (
              <h5 style={{ fontWeight: '600' }}>
                {props.dataItem[textStyleColumn3]}
              </h5>
            ) : (
              <h5
                style={{
                  color:
                    props.dataItem[textStyleColumn3] === 'Aceptada'
                      ? 'green'
                      : 'red',
                  fontWeight: '600',
                }}
              >
                {props.dataItem[textStyleColumn3]}
              </h5>
            )}
          </div>
        ) : (
          props.dataItem[fieldRow3]
          /*Texto sacado con props.dataItem[fieldRow2]*/
        )}
      </td>
    );
  };
  // const gridSignatureRequestPanelStyle = {
  //   minHeight: '470px',
  //   fontFamily: 'Quicksand, sans-serif',
  // };

  const gridColumnNoRecordsStyle = {
    color: '#2C353C',
    fontSize: '16px',
    fontWeight: 550,
    fontFamily: 'Quicksand',
  };

  const onPageChange = (event) => {
    setPage(event.page);
  };

  useEffect(() => {
    onSelectedItem(selectedItem);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedItem]);

  useEffect(() => {
    setPage(initialDataState);
  }, [dataGrid]);

  return (
    <Grid
      className={`gridSimpleReadHLPure ${customClassGrid}`}
      // style={gridSignatureRequestPanelStyle}
      data={dataGrid.slice(page.skip, page.take + page.skip)}
      reorderable
      skip={page.skip}
      take={page.take}
      pageable={pageableGrid}
      total={dataGrid.length}
      onPageChange={onPageChange}
      filter={filter}
      onChangeFilter={onFilterChange}
      rowRender={rowRender}
    >
      <GridColumn
        field={fieldRow1}
        title={titleRow1}
        cell={avatarCell}
        headerCell={SignRequestCellHeader}
      />
      {column2Status ? (
        <GridColumn
          field={fieldRow2}
          title={titleRow2}
          cell={columnTwoCell}
          headerClassName={styleHeader2}
          headerCell={SignRequestCellHeader}
        />
      ) : (
        ''
      )}
      {columnThree ? (
        <GridColumn
          field={fieldRow3}
          title={titleRow3}
          cell={columnThreeCell}
          headerClassName={styleHeader3}
          headerCell={SignRequestCellHeaderColum3}
        />
      ) : (
        ''
      )}
      {columnFour &&
        <GridColumn
          field={columnFourField}
          title={coulmnFourTitle}
          cell={columnFourCell}
          headerCell={SignRequestCellHeader}
        />}
      <GridNoRecords>
        {
          !noRecordsElement ? (
            <span style={gridColumnNoRecordsStyle}>
              {t('configurationDomainPanel.notResults')}
            </span>
          ) : noRecordsElement
        }
      </GridNoRecords>
    </Grid>
  );
};
export { GridSimpleReadHLPure as default };
